function clone (src) {
  return Object.assign({}, src);
}

function addScript (src) {
  var script = document.createElement('script');
  script.src = src;
  document.head.appendChild(script);
  return script
}

function addScripts (srcs) {
  if(srcs.length > 0){
    var script = addScript(srcs[0]);
    srcs.shift();
    script.onload = function() {
      addScripts(srcs)
    };
  }
}

function findKey(obj, key) {

  function findKeyRecursive(o, keyToBeFound) {

    var result = undefined;

    if(o){
      Object.keys(o).forEach(function (k) {

        if(result == undefined){
          if (typeof o[k] === 'object') {
            result = findKeyRecursive(o[k], keyToBeFound);
          }
          else {
            if (k === keyToBeFound){
              result = o[k]
            }
          }
        }
      });
      return result
    }
  }

  let resulta = findKeyRecursive(obj, key);

  return resulta
}

export {
  clone,
  addScript,
  addScripts,
  findKey
}
